import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import  { ReorderPointView } from "./reorderPoint-view"

export class ReorderPointViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تعیین نقطه سفارش';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.lineItems = ObservableArray.create<lineItem>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.warehouseSelector = new WarehouseSelector(this);
        this.warehouseSelector.onSelectionChanged = w =>{
            this.warehouseId = w.id;
            this.warehouseName = w.title;
            this.refresh();
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new ReorderPointView();
    }
    public getTypeId(): string {
        return "VM-2CEDDA69-C520-40D4-B68F-99BDCB050991"
    }

    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;
    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryServices/ListAllProductsWithTheirReorderPoint',{
                FurtherQueryInfo:filteringInformation,
                WarehouseId : this.warehouseId
            });
            this.lineItems.update(...result.Products.map(q=>{
                let r = new lineItem(this);
                r.measuredProductId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.unitName = q.UnitName;
                r.balance = q.Balance;
                r.availableBalance = q.AccessibleBalance;
                r.reorderPoint = q.ReorderPointAmount;
                r.reorderAmount = q.ReorderAmount;

                r.newReorderPoint = q.ReorderPointAmount;
                r.newReorderAmount = q.ReorderAmount;

                r.exists = q.Exists;
                r.isEdited = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async save(item:lineItem){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/InventoryServices/UpdateProductReorderPoint',{
                WarehouseId : this.warehouseId,
                MeasuredProductId:item.measuredProductId,
                ReorderPointAmount:item.newReorderPoint,
                ReorderAmount:item.newReorderAmount
            });
        } catch (ex) {
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }
    async invalidate(item:lineItem){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/InventoryServices/InvalidateReorderPoint',{
                WarehouseId : this.warehouseId,
                MeasuredProductId:item.measuredProductId,
            });
        } catch (ex) {
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }
}

export class lineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ReorderPointViewModel) {
        super(parent);
        this.typedParent = parent;
    }
    private typedParent : ReorderPointViewModel;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance;} private _availableBalance: number;
    public set reorderPoint(v: number) { this._reorderPoint = getAsNumber(v,true); } public get reorderPoint(): number { return this._reorderPoint;} private _reorderPoint: number;
    public set reorderAmount(v: number) { this._reorderAmount = getAsNumber(v,true); } public get reorderAmount(): number { return this._reorderAmount;} private _reorderAmount: number;
    
    public set newReorderPoint(v: number) { 
        this._newReorderPoint = getAsNumber(v,true); 
        this.isEdited = true;
    } public get newReorderPoint(): number { return this._newReorderPoint;} private _newReorderPoint: number;
    public set newReorderAmount(v: number) { 
        this._newReorderAmount = getAsNumber(v,true); 
        this.isEdited = true;
    } public get newReorderAmount(): number { return this._newReorderAmount;} private _newReorderAmount: number;
    
    public set exists(v: boolean) { this._exists = v; } public get exists(): boolean { return this._exists;} private _exists: boolean;
    public set isEdited(v: boolean) { this._isEdited = v; } public get isEdited(): boolean { return this._isEdited;} private _isEdited: boolean;
    
    async confirm(){
        let confirmation ='';
        if(this.exists){
            confirmation = await this.messageBoxWarningYesNo('آیا مقدار نقطه سفارش تغییر کند؟','تغییر نقطه سفارش');
        }else{
            confirmation = await this.messageBoxSuccessYesNo('آیا مقدار نقطه سفارش ایجاد شود؟','ایجاد نقطه سفارش');
        }
        if(confirmation=='no'){
            return;
        }
        try {
            await this.typedParent.save(this);
            this.reorderAmount = this.newReorderAmount;
            this.reorderPoint = this.newReorderPoint;
            this.exists = true;
            this.isEdited = false;
            await this.messageBoxConfirmSuccess('تعیین نقطه سفارش با موفقیت انجام شد','تعیین نقطه سفارش');
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
    async invalidate(){

        this.reorderPoint =0;
        this.reorderAmount =0;
        let confirmation =await this.messageBoxDangerYesNo('آیا نقطه سفارش حذف شود؟','حذف نقطه سفارش');
        if(confirmation=='no'){
            return;
        }
        try {
            await this.typedParent.invalidate(this)
            this.reorderPoint = 0;
            this.reorderAmount = 0;
            this.newReorderPoint = 0;
            this.newReorderAmount = 0;
            this.exists = false;
            this.isEdited = false;
            await this.messageBoxConfirmSuccess('حذف نقطه سفارش با موفقیت انجام شد','حذف نقطه سفارش');

        } catch (ex) {
            console.log(ex);
        } finally {
        }

    }

}